import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import useAxios from "../common/hook/useAxios";
import { toast } from "react-toastify";
import { FaSearch } from "react-icons/fa";
import { formatDate, formatDateForInput, parseDateString } from "../constant";
import Dropdown from "./Dropdown";
import axios from "axios";

const ReportHeader = ({
  title1,
  title2,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  search,
  setSearch,
  getReportData,
  uploadUrl,
  refreshData,
  id,
  name
}) => {
  const { user } = useContext(AuthContext);
  const { request } = useAxios();
  const [searchPatient, setSearchPatient] = useState([]);
  const [error, setError] = useState("");
  const [location, setLocation] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(location[0]?.value);
  const [selectedPatient, setSelectedPatient] = useState("");
  const [patientId, setPatientId] = useState(0);
  const [file, setFile] = useState([]);
  const [fileName, setFileName] = useState("");
  const [patientName, setPatientName] = useState("");
  const [uploadDate, setUploadDate] = useState(new Date());
  const [req, setReq] = useState("");
  const [inputValue, setInputValue] = useState(""); // Input value for search
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (user) {
      getLocation();
    }
  }, [user]);

  // useEffect(() => {
  //   if (id) {
  //     setPatientId(id)
  //   }
  // }, [id])

  useEffect(() => {
    setSelectedLocation(location[0]?.value);
  }, [location]);

  useEffect(() => {
    searchPatients();
  }, []);

  const searchPatients = () => {
    const url = `${process.env.REACT_APP_ORDER_CODE_URL}/Search/SearchPracticePatients?sJSONInput={"PracticeID":"${user?.PracticeID}","SearchKey":"${inputValue}","SearchBy":"0","isFromLogin":0}`;
    request(url, {
      method: "GET",
    })
      .then((res) => {
        setSearchPatient(res.Data);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error occurred while searching patients", {
          autoClose: 3000,
        });
      });
  };

  const getLocation = () => {
    const url = `${process.env.REACT_APP_DROPDOWN_DATA_URL}/GetLocationDetails?sInputJSON={"PracticeID":${user?.PracticeID}}`;
    request(url, {
      method: "GET",
    })
      .then((res) => {
        setLocation(
          res.map((item) => ({
            value: item.LocationId,
            label: item.LocationName,
          })),
        );
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error occurred while fetching location", {
          autoClose: 3000,
        });
      });
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value) {
      const filteredSuggestions =
        searchPatient &&
        searchPatient.filter((item) =>
          ( item.LastName.toLowerCase()).startsWith(value.toLowerCase())
          ||
          ( item.FirstName.toLowerCase()).startsWith(value.toLowerCase()),
        );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    // console.log(suggestion);

    setInputValue(suggestion.FirstName);
    setSearchPatient((patients) => [...patients, suggestion]);
    setSuggestions([]); // Clear suggestions after selection
    setPatientId(suggestion.PatientID);
    setPatientName(suggestion.LastName+ suggestion.FirstName);
    setSelectedPatient(suggestion.FirstName);
  };

  const handleSelected = (patient) => {
    setPatientId(patient.PatientID);
    setPatientName(patient.LastName+ patient.FirstName);
    setSelectedPatient(patient.FirstName);
    setSearchPatient([]);
  };

  // console.log(user);
  const handleUpload = async () => {
    const data = {
      objLab: {
        DOS: formatDate(uploadDate),
        PatientID: id ? id : patientId,
        PatientName: name ? name : patientName,
        PracticeID: user?.PracticeID,
        FileContent: file,
        DocumentName: fileName,
      },
    };
    const updatedData = JSON.stringify(JSON.stringify(data));
    // console.log(typeof data.objLab.PracticeID, updatedData);
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabResults/${uploadUrl}`;
    const response = await axios
      .post(url, updatedData, {
        headers: {
          Authorization: `Bearer ${user?.AuthToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // console.log(res);
        toast.success("File Uploaded Succesfully");
        refreshData();
      })
      .catch((err) => {
        // console.log(err);
        toast.error("Error while uploading file", {
          autoClose: 3000,
        });
      });
  };

  return (
    <div className="w-full">
      <div className="border border-blue-400 rounded-md w-full">
        <div className="text-center text-black bg-gray-200 rounded-md w-full text-2xl font-semibold">
          {title1}
        </div>

        <div className="flex flex-row items-center justify-center gap-2 bg-regal-blue p-1 rounded-md">
          <input
            type="file"
            className="w-1/4"
            onChange={(e) => {
              const selectedFile = e.target.files[0];
              setFileName(selectedFile?.name);
              if (selectedFile) {
                const reader = new FileReader();
                reader.onloadend = () => {
                  const base64String = reader.result.split(",")[1];
                  setFile(base64String);
                };
                reader.readAsDataURL(selectedFile);
              }
            }}
          />
          {!id &&
            <div>
              <label>Patient : </label>
              <div>
                <input
                  type="search"
                  placeholder="Add Patient"
                  value={inputValue}
                  onChange={handleInputChange}
                  className="relative p-1 rounded-lg"
                />
                {/* <FaSearch className="absolute top-1/2 left-2 transform -translate-y-1/2 text-gray-500" /> */}
                {suggestions?.length > 0 && (
                  <ul className="absolute w-1/4 bg-white border border-gray-300 mt-1 max-h-60 overflow-auto z-10">
                    {suggestions.map((suggestion) => (
                      <li
                        key={suggestion.id}
                        style={{ whiteSpace: "nowrap" }}
                        className="p-2 cursor-pointer hover:bg-gray-200"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        {suggestion.FirstName + suggestion.LastName}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          }
          <div>
            <label>File Name </label> <br></br>
            <input
              type="text"
              className="p-1 rounded-lg"
              value={fileName}
              onChange={(e) => setFileName(e.target.value)}
            />
          </div>
          {/* <div>
            <label>Req # : </label> <br></br>
            <input
              type="text"
              className="p-1 rounded-lg"
              value={req}
              onChange={(e) => setReq(e.target.value)}
            />
          </div> */}
          <div>
            <label>Date : </label> <br></br>
            <input
              type="date"
              id="from-date"
              value={formatDateForInput(uploadDate)}
              onChange={(e) => {
                const dateString = e.target.value;
                const newDate = parseDateString(dateString);
                if (newDate) {
                  setUploadDate(newDate); // Update the state with Date object
                  setError(""); // Clear any previous errors
                } else {
                  setError("Invalid date format.");
                }
              }}
              className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
          {/* <div>
            <label>Result Date : </label> <br></br>
            <input type="date" />
          </div> */}
          <div>
            <label>Location</label>
            <Dropdown
              items={location}
              label={""}
              setSelectedValue={setSelectedLocation}
              isHeader={true}
            />
          </div>
          <div className="flex flex-col gap-2">
            <button
              className="text-white text-sm px-1 py-1 rounded-md shadow-sm focus:outline-none bg-dark-orange"
              onClick={handleUpload}
            >
              Upload
            </button>
            <button className="text-white text-sm px-1 py-1 rounded-md shadow-sm focus:outline-none bg-dark-orange">
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div className="border border-blue-400 rounded-md w-full my-2">
        <div className="text-center text-black bg-gray-200 rounded-md w-full text-2xl font-semibold">
          {title2}
        </div>

        <div className="flex flex-row items-center justify-center gap-2 bg-regal-blue p-1 rounded-md">
          <div>
            <label>Search Name : </label> <br></br>
            <input
              type="search"
              placeholder="Search"
              className="p-1 rounded-lg"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div>
            <label>From Date </label> <br></br>
            <input
              type="date"
              id="from-date"
              value={formatDateForInput(fromDate)}
              onChange={(e) => {
                const dateString = e.target.value;
                const newDate = parseDateString(dateString);
                if (newDate) {
                  setFromDate(newDate); // Update the state with Date object
                  setError(""); // Clear any previous errors
                } else {
                  setError("Invalid date format.");
                }
              }}
              className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
          <div>
            <label>To Date </label> <br></br>
            <input
              type="date"
              id="from-date"
              value={formatDateForInput(toDate)}
              onChange={(e) => {
                const dateString = e.target.value;
                const newDate = parseDateString(dateString);
                if (newDate) {
                  setToDate(newDate); // Update the state with Date object
                  setError(""); // Clear any previous errors
                } else {
                  setError("Invalid date format.");
                }
              }}
              className="mt-1 block w-[200px] px-3 py-2 border border-gray-600 rounded-md bg-white text-black shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
          <button
            className=" text-white px-3 py-2 rounded-md shadow-sm focus:outline-none bg-dark-orange"
            onClick={getReportData}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportHeader;
